export default __webpack_public_path__ + "959589a6e26047f560eed6f329698d68.svg";